import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { AutoCompleteSelectionItem } from '../../core/component/autocomplete-remote/autocomplete-selection-item';
import { DataServiceBase } from '../../core/service/base/data.service.base';
import { MessageService } from '../../core/service/message.service';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { LettingShowing } from '../model/letting-showing';

@Injectable()
export class LettingAdvertismentOrdinaryService extends DataServiceBase {
  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(client, messageService, progressBar, config, 'letting-advertisment/ordinaries');
  }

  getSelectionItem(id: string): Observable<AutoCompleteSelectionItem<LettingShowing>> {
    return this.client.get<LettingShowing>(`${this.endpoint}/${id}`).pipe(
      map(data => this.createAutoCompleteSelectionItem(new LettingShowing(data))),
      catchError(e => {
        this.messageService.showError(e);
        return [];
      })
    );
  }

  getSelection(filter: string, options?: any, page?: number, maxItems?: number): Observable<AutoCompleteSelectionItem<LettingShowing>[]> {
    const queryArgs = {
      filter: filter,
      maxItems: maxItems || 20,
    };
    if (options) queryArgs['options'] = options;
    if (page > 0) queryArgs['page'] = page;

    return this.client.post<LettingShowing[]>(`${this.endpoint}`, queryArgs).pipe(
      map(data => data.map(item => this.createAutoCompleteSelectionItem(new LettingShowing(item)))),
      catchError(e => {
        this.messageService.showError(e);
        return [];
      })
    );
  }

  private createAutoCompleteSelectionItem(entity: LettingShowing): AutoCompleteSelectionItem {
    return new AutoCompleteSelectionItem(entity.name, entity.id, entity, entity.name);
  }
}
